function initCustomSelect() {
    const selects = document.querySelectorAll('.custom-select');

    const fields = document.querySelectorAll('.product-info__config .product-info__field');
    fields.forEach((field, index) => {
        field.style.zIndex = 99 - index;
    });

    selects.forEach(select => {
        const trigger = select.querySelector('.custom-select__trigger');
        const options = select.querySelectorAll('.custom-select__option');
        const selectId = select.dataset.selectId;

        trigger.addEventListener('click', (e) => {
            e.stopPropagation();

            document.querySelectorAll('.custom-select.is-open').forEach(s => {
                if (s !== select) s.classList.remove('is-open');
            });

            select.classList.toggle('is-open');
        });

        options.forEach(option => {
            option.addEventListener('click', (e) => {
                e.stopPropagation();

                const text = option.textContent.trim();

                trigger.querySelector('span').textContent = text;

                options.forEach(opt => opt.classList.remove('is-selected'));
                option.classList.add('is-selected');

                select.classList.remove('is-open');

                if (selectId === 'has-turntable') {
                    console.log('Has turntable clicked, selectId:', selectId);
                    const productUrl = option.dataset.productUrl;
                    console.log('Product URL:', productUrl);
                    if (productUrl) {
                        const config = {};
                        document.querySelectorAll('.product-info__config [data-select-id]').forEach(sel => {
                            const id = sel.dataset.selectId;
                            if (id && id !== 'has-turntable') {
                                const selectedOption = sel.querySelector('.custom-select__option.is-selected');
                                if (selectedOption) {
                                    config[id] = selectedOption.dataset.value;
                                }
                            }
                        });
                        console.log('Saved config:', config);
                        sessionStorage.setItem('productConfig', JSON.stringify(config));

                        window.location.href = productUrl;
                    } else {
                        console.log('No product URL found on this option');
                    }
                }
            });
        });

        const savedConfig = sessionStorage.getItem('productConfig');
        if (savedConfig) {
            const config = JSON.parse(savedConfig);

            if (selectId && config[selectId]) {
                const savedOption = select.querySelector(`[data-value="${config[selectId]}"]`);
                if (savedOption) {
                    savedOption.click();
                }
            }

            sessionStorage.removeItem('productConfig');
        }
    });

    document.addEventListener('click', () => {
        document.querySelectorAll('.custom-select.is-open').forEach(select => {
            select.classList.remove('is-open');
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomSelect);
} else {
    initCustomSelect();
}
